import { createLogic } from "redux-logic";
import { IntegrationsActions, INTEGRATIONS_LOCAL_STORAGE_KEYS } from "../types";
import { getLocal } from "../../../data/localStorageHelpers";
var orderPlaced = createLogic({
    type: IntegrationsActions.INTEGRATIONS_EVENT_ORDER_PLACED,
    latest: true,
    process: function (_a, dispatch, done) {
        var _b;
        var getState = _a.getState, action = _a.action;
        var integrations = getState().integrations;
        var typedAction = action;
        var order = typedAction.payload.result;
        var config = (_b = integrations.integrations["REFERRAL_ROCK"]) === null || _b === void 0 ? void 0 : _b.config;
        if (config) {
            window.referralJS = ((window.referralJS !== null && window.referralJS !== undefined) ? window.referralJS : {});
            var referralCode_1 = getLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_CODE);
            var prefix = Object.keys(config.codes).find(function (code) { return referralCode_1 === null || referralCode_1 === void 0 ? void 0 : referralCode_1.toUpperCase().startsWith(code.toUpperCase()); });
            var programIdentifier_1 = prefix ? config.codes[prefix].programIdentifier : undefined;
            window.referralJS.conversion = {
                parameters: {
                    referralCode: referralCode_1,
                    firstName: order.firstName,
                    lastName: order.lastName,
                    email: order.email,
                    externalIdentifier: order.orderKey,
                    amount: order.total,
                    customFields: {
                        customText: {
                            "Event": order.eventNumber,
                            "Order": order.orderKey,
                        }
                    }
                }
            };
            if (programIdentifier_1) {
                if (window.showConfirmationModal) {
                    window.showConfirmationModal('<iframe id="rr-iframe" name="rr-iframe" allowFullScreen="true" width="100%" height="300px" style="border: 0"></iframe><div class="absolute-center" id="rr-loader"><span class="global-loader-container"><div class="dots-9 "></div></span></div>', " ");
                }
                setTimeout(function () {
                    var _a;
                    window.referralJS = ((window.referralJS !== null && window.referralJS !== undefined) ? window.referralJS : {});
                    window.referralJS.access = {
                        targetId: "rr-iframe",
                        parameters: {
                            view: "iframe",
                            programIdentifier: programIdentifier_1,
                            email: order.email,
                            firstName: order.firstName,
                            lastName: order.lastName,
                            customFields: {
                                customText: {
                                    "Event": order.eventNumber,
                                    "Order": order.orderKey,
                                }
                            }
                        }
                    };
                    (_a = document.getElementById("rr-loader")) === null || _a === void 0 ? void 0 : _a.remove();
                    done();
                }, 5000);
            }
            else {
                done();
            }
        }
        else {
            done();
        }
    },
});
var exportable = [orderPlaced];
export default exportable;
